import { useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { resendRegistrationCode, verifyEmail } from '../services/authService';
import './Login.css';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const location = useLocation();
  const nav = useNavigate();
  const emailFromQuery = params.get('email') || '';
  const [email, setEmail] = useState(emailFromQuery);
  const [code, setCode] = useState('');
  const [message, setMessage] = useState(location.state?.notice || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Email is required.');
      return;
    }
    if (!code || code.length !== 6) {
      setError('Enter the 6-digit verification code.');
      return;
    }

    setLoading(true);
    try {
      const res = await verifyEmail(email, code);
      setMessage(res?.message || 'Email verified successfully. You can login now.');
      setTimeout(() => {
        nav('/login', { replace: true });
      }, 1200);
    } catch (err) {
      setError(err.message || 'Verification failed.');
    } finally {
      setLoading(false);
    }
  };

  const resendCode = async () => {
    setError('');
    setMessage('');
    if (!email) {
      setError('Email is required to resend code.');
      return;
    }
    setResending(true);
    try {
      const res = await resendRegistrationCode(email);
      setMessage(res?.message || 'A new verification code has been sent.');
    } catch (err) {
      setError(err.message || 'Unable to resend verification code.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div>
            <p className="login-eyebrow">SFACO-CTG</p>
            <h1>Email verification</h1>
            <p className="login-subtitle">Enter the code sent to your email to complete registration.</p>
          </div>
        </div>

        <form className="login-form" onSubmit={submit}>
          <label>
            Email address
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>

          <label>
            Verification code
            <input
              type="text"
              value={code}
              onChange={(event) => setCode(event.target.value.replace(/\D/g, '').slice(0, 6))}
              inputMode="numeric"
              pattern="\d{6}"
              placeholder="Enter 6-digit code"
              required
            />
          </label>

          {message && <p className="register-message">{message}</p>}
          {error && <p className="register-error">{error}</p>}
          <button className="login-submit" type="submit" disabled={loading}>
            {loading ? 'Verifying...' : 'Verify code'}
          </button>
          <button className="login-secondary" type="button" onClick={resendCode} disabled={resending}>
            {resending ? 'Sending...' : 'Resend code'}
          </button>
          <Link className="back-home" to="/">Back to home</Link>
        </form>
      </div>
    </div>
  );
}
